module.exports = __webpack_public_path__ + "static/media/id10-5.9519da32.png";